import script from "./MyBetsSlips.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBetsSlips.vue?vue&type=script&setup=true&lang=js"

import "./MyBetsSlips.vue?vue&type=style&index=0&id=261a856e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261a856e"]])

export default __exports__